import React, { FunctionComponent, Fragment } from 'react'
import { graphql } from 'gatsby'
import { IndexQuery } from '../graphqlTypes'
import Layout from '../components/Layout'
import PostExcerpt from '../components/PostExcerpt'
import Seo from '../components/Seo'

interface Props {
  data: IndexQuery
}

export const pageQuery = graphql`
  query Index {
    posts: allFile(filter: {sourceInstanceName: {eq: "posts"}, internal: {mediaType: {eq: "text/markdown"}}}, sort: {order: DESC, fields: ctimeMs}, limit: 10) {
      edges {
        post: node {
          childMarkdownRemark {
            id
            frontmatter {
              title
              tags
              slug
              date
              headerImageAlt
              headerImage {
                childImageSharp {
                  fluid(maxWidth: 800, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            excerpt
            timeToRead
          }
          relativeDirectory
          changeTime(formatString: "MMMM Do, YYYY")
        }
      }
    }
  }
`

const getSlug = (relativeDirectory: string, slug?: string | null): string => (slug !== null) ? slug as string : relativeDirectory

const Index: FunctionComponent<Props> = ({ data: { posts: { edges: posts } } }: { data: IndexQuery }) => {
  return (
    <Layout>
      <Seo title='Welcome' />
      {posts.map(({ post }, i) => {
        const slug = getSlug(post.relativeDirectory, post.childMarkdownRemark?.frontmatter?.slug)
        return (
          <Fragment key={i}>
            <PostExcerpt
              slug={slug}
              title={post.childMarkdownRemark?.frontmatter?.title as string}
              excerpt={post.childMarkdownRemark?.excerpt as string}
              timeToRead={post.childMarkdownRemark?.timeToRead as number}
              tags={post.childMarkdownRemark?.frontmatter?.tags}
              headerImage={{
                fluid: post.childMarkdownRemark?.frontmatter?.headerImage?.childImageSharp?.fluid,
                alt: post.childMarkdownRemark?.frontmatter?.headerImageAlt
              }}
              date={post.childMarkdownRemark?.frontmatter?.date as Date}
            />
          </Fragment>
        )
      })}
    </Layout>
  )
}

export default Index
